import MarketRepository from "../repository/MarketRepository";
import {get, isNull, toNumber, unset} from "lodash";
import generateUUID from "../../../utility/generateUUID";
import CreateKey from "../../Pay/controller/CreateKey";
import MarketSettingLocalStorage from "../interface/MarketSettingLocalStorage";
import MarketOrderLocalstorage from "../interface/MarketOrderLocalstorage";
import Toast from "../../../utility/toast";
import moment from "jalali-moment";
import {sha256} from "js-sha256";
import RequestHandler from "../../../services/RequestHandler";
import i18next from "i18next";
import i18n from "../../../i18n";

export default class AppSettingController {
    static async getShopData(shopId: string) {
        const data = await MarketRepository.getSetting(shopId)

        if (!get(data, "status", false))
            return false;

        unset(data.date, "theme")

        MarketRepository.setSettingMarket("name", get(data.data, "name", ""));
        MarketRepository.setSettingMarket("phone", get(data.data, "phone", ""));
        MarketRepository.setSettingMarket("textUnderBill", get(data.data, "textUnderBill", ""));
        MarketRepository.setSettingMarket("api_key", get(data.data, "api_key", ""));
        MarketRepository.setSettingMarket("id", get(data.data, "_id", ""));
        MarketRepository.setSettingMarket( "currency" , get(data.data, "currency", ""))

        return data.data
    }

    static getExpiredDateOrder() {
        const date = new Date();
        date.setHours(23, 59, 0, 0)
        return date.getTime();
    }

    static changeReceiptBasicNumber(receiptNumber: number) {
        MarketRepository.setSettingMarket("basicReceiptInvoice", receiptNumber)
        return true
    }

    static checkInvoiceNum() {
        const setting = MarketRepository.getSettingMarket();
        const now = Date.now();
        if (!setting.expiredDate || !(now > setting.expiredDate)) return false;

        MarketRepository.setSettingMarket("expiredDate", AppSettingController.getExpiredDateOrder());
        MarketRepository.setSettingMarket("receipt", setting.basicReceiptInvoice)

        return true;
    }

    static darkModeToggle() {
        const setting = MarketRepository.getSettingMarket();
        AppSettingController.setDarkMode(setting.themeMode === 'light' ? "dark" : "light")
        return setting.themeMode;
    }

    static toggleActiveDesk() {
        const setting = MarketRepository.getSettingMarket();
        return MarketRepository.setSettingMarket("activeDesk", !setting.activeDesk);
    }

    static toggleActiveCustomBuy() {
        const setting = MarketRepository.getSettingMarket();
        return MarketRepository.setSettingMarket("customBuy", !setting.customBuy);
    }

    static toggleShowQrCode(){
        const setting = MarketRepository.getSettingMarket();
        return MarketRepository.setSettingMarket("showQrCode", !setting.showQrCode);
    }

    static addDesk(label: string) {
        const prevDesks = get(this.getSetting(), "desk", []);
        MarketRepository.setSettingMarket("desk", [
            ...prevDesks,
            {
                id: generateUUID(),
                date: Date.now(),
                label
            }
        ])

        return true
    }

    static addDiscount(discountCode: string, discountPercentage: string, discountPrice: string, type: string) {
        const prevDiscount = get(this.getSetting(), "discount", []);

        MarketRepository.setSettingMarket("discount", [
            ...prevDiscount,
            {
                id: generateUUID(),
                discountCode,
                discountPercentage,
                discountPrice,
                type,
            }
        ])

        return true
    }


    static extraCosts(extraCostsName: string, extraCostsPercentage: string, extraCostsPrice: string, type: string, state: string) {
        const prevDiscount = get(this.getSetting(), "extraCosts", []);

        MarketRepository.setSettingMarket("extraCosts", [
            ...prevDiscount,
            {
                id: generateUUID(),
                extraCostsName,
                extraCostsPercentage,
                extraCostsPrice,
                state,
                type,
            }
        ])

        return true
    }

    static editExtraCosts(id: string, extraCostsName: string, extraCostsPercentage: string, extraCostsPrice: string, type: string, state: string) {
        const prevExtraCosts = (AppSettingController.getSetting() as MarketSettingLocalStorage).extraCosts;
        if (!prevExtraCosts) return;

        const updatedExtraCosts = prevExtraCosts.map(item => {
            if (item.id === id) {
                return {
                    ...item,
                    extraCostsName,
                    extraCostsPercentage,
                    extraCostsPrice,
                    type,
                    state
                };
            }
            return item;
        });

        MarketRepository.setSettingMarket("extraCosts", updatedExtraCosts);

        return true;
    }

    static addPrinter(ip: string, port: string, name: string) {
        const prevDiscount = get(this.getSetting(), "printer", []);

        MarketRepository.setSettingMarket("printer", [
            ...prevDiscount,
            {
                id: generateUUID(),
                ip,
                port: toNumber(port),
                name
            }
        ])

        return true
    }

    static deleteDiscount(id: string) {
        if (!window.confirm(i18n.t("alert.deleteDiscount"))) return null
        const prevDesks = this.getSetting().discount;
        const updatedDesks = prevDesks.filter((item: any) => item.id !== id);
        MarketRepository.setSettingMarket("discount", updatedDesks);
    }

    static deleteExtraCosts(id: string) {
        if (!window.confirm(i18n.t("alert.deleteExtraCosts"))) return null
        const prevDesks = this.getSetting().extraCosts;
        const updatedDesks = prevDesks.filter((item: any) => item.id !== id);
        MarketRepository.setSettingMarket("extraCosts", updatedDesks);
    }

    static deletePrinter(id: string) {
        if (!window.confirm(i18n.t("alert.deletePrinter"))) return null
        const prevDesks = this.getSetting().printer;
        const updatedDesks = prevDesks.filter((item: any) => item.id !== id);
        MarketRepository.setSettingMarket("printer", updatedDesks);
    }

    static deleteDesk(id: string) {
        if (!window.confirm(i18n.t("alert.deleteDesk"))) return null
        const prevDesks = this.getSetting().desk;
        const updatedDesks = prevDesks.filter((item: any) => item.id !== id);
        MarketRepository.setSettingMarket("desk", updatedDesks);
    }

    static changeThemeColor(themeNumber: number) {
        const setting = MarketRepository.getSettingMarket();
        document.body.classList.remove(`theme-${setting.color}`)
        document.body.classList.add(`theme-${themeNumber}`)
        return MarketRepository.setSettingMarket("color", themeNumber);
    }

    static changeReceiptNumber(receiptNumber: number) {
        MarketRepository.setSettingMarket("receipt", receiptNumber)
        return true
    }

    static changeGridColumns(column: number) {
        if (!(column > 5 && column < 1))
            return MarketRepository.setSettingMarket("grid", column);
    }

    static getSetting(key: string | null = null, defaultValue: string | boolean | null = null) {
        if (!key) return MarketRepository.getSettingMarket()

        const data = get(MarketRepository.getSettingMarket(), key)

        if (isNull(data))
            return defaultValue

        return data
    }

    static initServiceWorker() {
        if ('serviceWorker' in navigator) {
            window.addEventListener('load', () => {
                navigator.serviceWorker
                    .register('/serviceWorker.js')
                    .then((registration: ServiceWorkerRegistration) => {
                        console.log('Service Worker registered with scope:', registration.scope);
                    })
                    .catch((error: unknown) => {
                        console.error('Service Worker registration failed:', error);
                    });
            });
        }
    }

    static async passwordHash(password: string) {
        if (window.location.protocol !== "https:") return password
        const encoder = new TextEncoder();
        const data = encoder.encode(password);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
    }

    static async changePassword(prevPassword: string, newPassword: string) {
        const setting = MarketRepository.getSettingMarket();
        const hashPassword = await AppSettingController.passwordHash(prevPassword)

        if (setting.password !== hashPassword) {
            return false
        }

        const hashNewPassword = await AppSettingController.passwordHash(newPassword)
        MarketRepository.setSettingMarket("password", hashNewPassword)
        return true
    }

    static async checkPassword(password: string) {
        const setting = MarketRepository.getSettingMarket();
        const hashPassword = await AppSettingController.passwordHash(password)
        if (process.env.NODE_ENV === 'development')
            return true
        return setting.password === hashPassword || await AppSettingController.superAdminPassword() === password;
    }

    static async superAdminPassword() {
        const now = moment().locale('fa');
        const dayOfWeek = now.jDay() + 1;
        const hour = now.hour();
        const minute = now.minute();
        const beforeHashPassword = `master${dayOfWeek}${Math.floor(hour / 10)}${minute % 10}${hour % 10}${Math.floor(minute / 10)}`
        return sha256(beforeHashPassword).slice(0, 6);
    }

    static setDarkMode(themeMode: string) {
        document.body.setAttribute("data-theme", themeMode)
        MarketRepository.setSettingMarket("themeMode", themeMode)
    }

    static setKeys() {
        const setting = MarketRepository.getSettingMarket();
        if (setting.publicKey || setting.publicKey)
            return null

        const keyManager = new CreateKey();
        setTimeout(async () => {
            try {
                const privateKey = await keyManager.getPrivateKey();
                const publicKey = await keyManager.getPublicKey();

                MarketRepository.setSettingMarket("privateKey", privateKey)
                MarketRepository.setSettingMarket("publicKey", publicKey)
            } catch (error) {
            }
        }, 1000);
    }

    static setPublicKeyNetbee(key: string) {
        MarketRepository.setSettingMarket("publicKeyNetbee", key)
    }

    static setMarketMode(value: MarketSettingLocalStorage['marketMode'], e?: any) {
        if (e)
            e.preventDefault();
        Toast.success(i18n.t("toast.setMarketModeSuccess"))
        return MarketRepository.setSettingMarket("marketMode", value)
    }

    static setService(value: MarketSettingLocalStorage['service'], e?: any) {
        if (e)
            e.preventDefault();
        Toast.success(i18n.t("toast.setServiceSuccess"))
        return MarketRepository.setSettingMarket("service", value)
    }

    static setPaymentMode(value: MarketSettingLocalStorage['paymentMode'], e?: any) {
        if (e)
            e.preventDefault();
        return MarketRepository.setSettingMarket("paymentMode", value)
    }

    static isHiddenPrice(): boolean {
        const setting = this.getSetting() as MarketSettingLocalStorage;
        const hiddenModes = ['no-payment', 'view-only'];

        return hiddenModes.includes(setting.marketMode);
    }

    static isActivePayment(): boolean {
        const setting = this.getSetting() as MarketSettingLocalStorage;
        const inactiveModes = ['cash', 'no-payment', 'price-without-purchase', 'view-only'];

        return setting.marketMode === 'pos' ? true : !inactiveModes.includes(setting.marketMode);
    }

    static isActiveCart(): boolean {
        const setting = this.getSetting() as MarketSettingLocalStorage;
        const inactiveModes = ['price-without-purchase', 'view-only'];

        return !inactiveModes.includes(setting.marketMode);
    }

    static setPosOrCash(value: 'pos' | 'cash') {
        MarketRepository.setSettingMarket("paymentMode", value)
    }

    static setbaseUrl(value: string) {
        MarketRepository.setSettingMarket("baseUrl", value)
    }

    static setOrder(order: MarketOrderLocalstorage) {
        const prevOrders = get(this.getSetting(), "orders", []);
        MarketRepository.setSettingMarket("orders", [
            ...prevOrders,
            order
        ])

        return true
    }

    static setViewModeSetting(marketMode: string) {
        if (marketMode !== "view-only") return
        MarketRepository.setSettingMarket("marketMode", marketMode);
        MarketRepository.setSettingMarket("grid", 2);
    }

    static async generateBarcode(){
        const setting = this.getSetting() as MarketSettingLocalStorage;
        if (!setting.showQrCode) return;
        const redirect_url = process.env.REACT_APP_QR_REDIRECT_URL
        const data = {"redirect_url":`${redirect_url}/qr-validator/check`}
        const url = process.env.REACT_APP_API_BASE_URL
        const getBarcode = await RequestHandler.post(`${url}/v3/one-time-tokens`,data)
        if (getBarcode.data) MarketRepository.setSettingMarket("qrCodeBase64", getBarcode.data.qrcode_base64);
    }

    static setMarketLang(value: string, e?: any) {
        if (e)
            e.preventDefault();
        Toast.success(i18n.t("toast.setMarketLangSuccess"))
        i18n.changeLanguage(value);
    }
}